import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { useTheme } from '@mui/material';
import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { getFromStorage, saveInStorage } from '../../utils/storage';
import { Banner } from './Banner';

type Props = {
  title?: string;
  children: ReactNode;
  dismissStorageKey?: string;
};

export const InfoBanner: FC<Props> = ({ title, children, dismissStorageKey }) => {
  const theme = useTheme();
  const storageKey = dismissStorageKey ? `infoBanner_${dismissStorageKey}` : undefined;
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!storageKey) {
      return;
    }
    setIsDismissed(getFromStorage<boolean>(storageKey, false));
  }, [storageKey]);

  if (isDismissed) {
    return null;
  }

  const handleDismiss = storageKey
    ? (): void => {
        saveInStorage(storageKey, true);
        setIsDismissed(true);
      }
    : undefined;

  return (
    <Banner
      backgroundColor={theme.palette.SlabBlue.IceLight}
      borderColor='#EAEDF9'
      icon={<InfoOutlineIcon sx={{ width: '24px', height: '24px', color: '#6B8AFC' }} />}
      title={title}
      onDismiss={handleDismiss}
    >
      {children}
    </Banner>
  );
};
